'use client'

import { useState } from 'react'

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const faqs = [
    {
      question: 'What kinds of problems can custom software solve?',
      answer:
        'If your team spends hours on repetitive tasks—data entry, report generation, customer tracking, file management, notifications—you are losing time and money every week. Custom software automates these workflows so your team can focus on high-value work. Most clients recover 10-20 hours per week within the first month.',
    },
    {
      question: 'How will I interact with my custom software?',
      answer:
        'However works best for you: web dashboards, mobile apps, API endpoints, or direct integration with tools you already use (Slack, email, your CRM). We also provide a management dashboard where you control settings and view real-time reports. No technical skills required.',
    },
    {
      question: 'How does your pricing work?',
      answer:
        'Zero upfront cost—we take on the development risk. You only pay after your solution is live and working. Then it is simple usage-based monthly billing with no hidden fees. Most clients find this 40-60% cheaper than hiring developers or agencies with traditional contracts.',
    },
    {
      question: 'What if I am not satisfied with the result?',
      answer:
        'Since you pay nothing until the solution is live and delivering value, there is no risk. We iterate based on your feedback until you are completely satisfied. And with monthly billing, you are never locked into long-term contracts—though 94% of our clients stay with us for 2+ years.',
    },
    {
      question: 'Can you work as part of our internal team?',
      answer:
        'Absolutely. We can operate as embedded contractors, working alongside your developers on your infrastructure. In these cases, we work on an hourly basis and integrate directly into your workflow, Slack channels, and sprint cycles.',
    },
  ]

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section id="faq" className="faq-section">
      <div className="container">
        <div className="faq-layout">
          <h2 className="faq-title font-logo">FAQ</h2>
          <div className="faq-accordion">
            {faqs.map((faq, index) => (
              <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
                <button className="faq-question" onClick={() => toggleFAQ(index)}>
                  <span>{faq.question}</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={`faq-icon ${openIndex === index ? 'faq-icon-open' : ''}`}>
                    {/* Solid arrow pointing right - rotated 45deg when open */}
                    <path d="M3 8L13 8M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                  </svg>
                </button>
                {faq.answer && <div className="faq-answer">{faq.answer}</div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
